import React, { useState, useRef } from 'react'
import { DateRangePicker as DateRangePickerMUI } from '@mui/x-date-pickers-pro'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { Box, Button, TextField } from '@mui/material'
import { dateFormatter } from 'utils/data-manipulation/valueFormatter'
import { useSelector } from 'react-redux'
import { getDateFormatPatternFromLocale } from 'utils/helpers'
import dayjs from 'dayjs'

const useRenderDateRangePicker = () => {
  const [value, setValue] = useState([null, null])
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const isClearingRange = useRef(false)

  // All of these are used to close fields after selecting range
  const [open, setOpen] = useState(false)
  const [isAccept, setIsAccept] = useState(false)
  const [isTextField, setIsTextField] = useState(false)

  const { locale } = useSelector(state => state.auth)
  const { dateFormat } = getDateFormatPatternFromLocale(locale)

  const formatDate = value => {
    const dateValue = new Date(value).getTime()
    const inputValue = !isNaN(dateValue) && dayjs(dateValue).isValid() ? dateFormatter(dateValue) : value

    return inputValue
  }

  const renderDateRangePicker = () => (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePickerMUI
        value={value}
        onChange={newValue => {
          if (isClearingRange.current) {
            isClearingRange.current = false
            return
          }
          const localStartDate = newValue && dayjs(newValue[0]).isValid() ? new Date(newValue[0]) : ''
          setStartDate(localStartDate)

          const localEndDate = newValue && dayjs(newValue[1]).isValid() ? new Date(newValue[1]) : ''
          setEndDate(localEndDate)

          setValue(newValue)
        }}
        open={open}
        defaultValue={[null, null]}
        onAccept={() => {
          setIsAccept(true)
        }}
        onClose={() => {
          setIsAccept(false)
          if (!isTextField) {
            setOpen(false)
            setIsTextField(false)
          }
        }}
        onOpen={() => {
          if (!isAccept) {
            setOpen(true)
          }
        }}
        renderInput={(startProps, endProps) => {
          return (
            <>
              <TextField
                {...startProps}
                sx={{ width: 130 }}
                onFocus={() => {
                  setIsTextField(true)
                }}
                onBlur={() => {
                  setIsTextField(false)
                }}
                onClick={() => {
                  setOpen(true)
                }}
                onKeyDown={e => e.preventDefault()}
                inputProps={{
                  ...startProps.inputProps,
                  value: formatDate(startDate),
                  placeholder: dateFormat,
                }}
              />
              <Box sx={{ mx: 2 }}> to </Box>
              <TextField
                {...endProps}
                sx={{ width: 130 }}
                onFocus={() => {
                  setIsTextField(true)
                }}
                onBlur={() => {
                  setIsTextField(false)
                }}
                onClick={() => {
                  setOpen(true)
                }}
                onKeyDown={e => e.preventDefault()}
                inputProps={{
                  ...endProps.inputProps,
                  value: formatDate(endDate),
                  placeholder: dateFormat,
                }}
              />
            </>
          )
        }}
      />
      <Button
        variant="text"
        onClick={() => {
          setValue([null, null])
          setStartDate('')
          setEndDate('')
          isClearingRange.current = true
        }}
      >
        Clear range
      </Button>
    </LocalizationProvider>
  )

  return {
    renderDateRangePicker,
    startDate,
    endDate,
  }
}

export default useRenderDateRangePicker
